import { UndefinedInitialDataOptions, useQuery } from '@tanstack/react-query'
import { isAddress } from 'thirdweb'
import { getNftContractMetadata } from '../api-clients/alchemy'
import useActiveOrDefaultChain from '../hooks/web3/useActiveOrDefaultChain'
import { NFT } from '../types/models/Tokens'

type NftContractMetadataQueryOptions = Omit<
  UndefinedInitialDataOptions<NFT | null>,
  'queryFn' | 'queryKey'
>

const useNftContractMetadata = (
  address?: string,
  options?: NftContractMetadataQueryOptions
) => {
  const chain = useActiveOrDefaultChain()

  const { enabled, ...rest } = options ?? {}

  return useQuery({
    queryFn: () => getNftContractMetadata(address, chain.id),
    enabled: (!!address && isAddress(address)) || enabled,
    queryKey: ['nftContractMetadata', address],
    ...rest,
  })
}

export default useNftContractMetadata
